import 'react-app-polyfill/ie11';
import 'url-search-params-polyfill';
import 'formdata-polyfill';
import { Link, Route, Switch } from 'react-router-dom';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { HashRouter } from 'react-router-dom';
import { forceHomeHref, forceLoginHref } from './util';
import { Login, Reset, Reset2, registerPanel, frame, toBeImplemented } from './Login';
import registerServiceWorker from './registerServiceWorker';
import { Panel } from './Panel';
import DocumentTitle from 'react-document-title';
import * as Util from './util';
import 'bootstrap'; // this is at least partly js

import * as ClientHome from './client/Home';

// theme css
import './index.css';
import './css/core.min.css';
import './css/app.css';
import './css/style.css';
import './App.css';

export interface AccountProps {
    accountType: string;
    id: string;
    superAdmin: boolean;
    kycAdmin: boolean;
}

interface AsyncState {
    Component?: React.ComponentClass;
}

const wrapAsync = (f: () => Promise<React.ComponentClass>, g: (c: React.ComponentClass, props: object) => JSX.Element) => {
    return (
        class AsyncComponent3 extends React.Component<object, AsyncState> {
            constructor(props: object) {
                super(props);
                this.state = {};
            }
            async componentDidMount() {
                this.setState({Component: (await f())});
            }
            render() {
                const { Component } = this.state;
                if (Component) {
                    return g(Component, this.props);
                } else {
                    return null;
                }
            }
        }
    );
};
const consultantCreate = async () => (await import('./register/ConsultantCreate')).ConsultantCreate;
const consultantRegister = async () => (await import('./register/Consultant')).ConsultantRegister;
const consultantReview = async () => (await import('./review/Consultant')).ConsultantReview;
const consultant = async () => (await import('./pages/ConsultantSummary')).ConsultantSummary;
const client = async () => (await import('./pages/Client')).ClientPage;
const selfProfile = async () => (await import('./pages/SelfProfile')).SelfProfile;
const selfProfile2 = async () => (await import('./pages/SelfProfile')).SelfProfile2;
const consultants = async () => (await import('./pages/Consultants')).Consultants;
const consultantData = async () => (await import('./pages/ConsultantData')).ConsultantData;
const admins = async () => (await import('./pages/Admins')).Admins;
const contracts = async () => (await import('./pages/Contracts')).Contracts;
const proposals = async () => (await import('./pages/Proposals')).Proposals;
const proposal = async () => (await import('./pages/Proposal2')).Proposal2Page;
const proposal3 = async () => (await import('./pages/Proposal3')).Proposal3Page;
const account = async () => (await import('./pages/Account')).Account;
const profile = async () => (await import('./pages/Profile')).Profile;
const profileVersions = async () => (await import('./pages/ProfileVersions')).ProfileVersions;
const userLogs = async () => (await import('./pages/UserLogs')).UserLogs;
const availability = async () => (await import ('./pages/Availability')).Availability;
const changePassword = async () => (await import('./pages/ChangePassword')).ChangePassword;
const clients = async () => (await import('./pages/Clients')).Clients;
const kyc = async () => (await import('./register/KYC')).KYC;
const reminders = async () => (await import('./pages/Reminders')).Reminders;
const test = async () => (await import('./pages/Test')).Test;

const thanks = () => frame(
    <div className="m-3">
        Thank you.  We will be in touch soon. <Link to="login">Home </Link>
    </div>
);

class App extends React.Component<AccountProps, object> {
    render() {
        const renderSelfProfile = (SelfProfile: any) => <SelfProfile accountType={this.props.accountType}/>;
        const renderConsultants = (Consultants: any) => <Consultants accountType={this.props.accountType} id={this.props.id} superAdmin={this.props.superAdmin} />;
        const renderAccount = (Account: any, props: any) => {
            const {version} = Util.queryString();
            return (
                <Account
                    accountType={this.props.accountType}
                    id={this.props.id}
                    {...props}
                    version={version}
                />
            );
        };
        const renderProfile = (Profile: any, props: any) => {
            const {version} = Util.queryString();
            return <Profile id={this.props.id} {...props.match.params} version={version} />;
        };
        const renderRegisterConsultantAdmin = (ConsultantRegister: any, props: any) => <ConsultantRegister adminCreated={true} />;
        const renderProposal = (Proposal: any, props: any) => {
            const _id = props.match.params.id;
            const viewer = this.props.id;
            return <Proposal _id={_id === 'new' ? undefined : _id} accountType={this.props.accountType} viewer={viewer}/>;
        };
        const renderConsultant = (Consultant: any, props: any) => (
            <Consultant
                id={props.match.params.id}
                admin={this.props.id}
                accountType={this.props.accountType}
                superAdmin={this.props.superAdmin}
                kycAdmin={this.props.kycAdmin}
            />
        );
        const renderAvailability = (AvailabilityCalendar: any, props: any) => (
            <AvailabilityCalendar adminViewer={this.props.accountType === 'admin'} id={props.match.params.id} accountType={this.props.accountType} />
        );
        const renderDefault = (X: any, props: any) => {
            const params = Util.queryString();
            return (
                <X
                    id={this.props.id}
                    superAdmin={this.props.superAdmin}
                    kycAdmin={this.props.kycAdmin}
                    accountType={this.props.accountType}
                    version={params.version}
                    {...props}
                />
            );
        };
        const renderKyc = (KYC: any, props: any) => {
            const kycIndex = Number(location.href.split('=')[1]);
            return (
                <KYC
                    _id={props.match.params.id || this.props.id}
                    token={props.match.params.token}
                    admin={Boolean(this.props.id)}
                    kycIndex={kycIndex}
                    superAdmin={this.props.superAdmin}
                    kycAdmin={this.props.kycAdmin}
                    accountType={this.props.accountType}
                />);
        };
        const renderUserLogs = (UserLogs: any) => (
            <UserLogs
                admin={this.props.id}
                accountType={this.props.accountType}
                superAdmin={this.props.superAdmin}
            />
        );
        return (
            <DocumentTitle title="KorumLegal Axceller">
                <Switch>
                    <Route exact={true} path="/registerConsultantThankYou" component={thanks} />
                    <Route exact={true} path="/login" component={Login} />
                    <Route exact={true} path="/login/reset" component={Reset}/>
                    <Route exact={true} path="/login/register" component={registerPanel}/>
                    <Route path="/reset/:token" component={Reset2}/>
                    <Route exact={true} path="/registerConsultant" component={wrapAsync(consultantRegister, renderDefault)} />
                    <Route exact={true} path="/registerConsultantAdmin" component={wrapAsync(consultantRegister, renderRegisterConsultantAdmin)} />
                    <Route exact={true} path="/home" render={() => <Panel accountType={this.props.accountType} superAdmin={this.props.superAdmin} />}/>
                    <Route path="/consultantReview/:id" component={wrapAsync(consultantReview, renderDefault)} />
                    <Route path="/createAccountConsultant/:id/:token" component={wrapAsync(consultantCreate, renderDefault)} />
                    <Route path="/createAccountConsultantAdmin/:id/:token" component={wrapAsync(consultantCreate, renderDefault)} />
                    <Route path="/selfProfile" component={wrapAsync(selfProfile, renderSelfProfile)} />
                    <Route path="/selfProfile2" component={wrapAsync(selfProfile2, renderDefault)} />
                    <Route path="/admins" component={wrapAsync(admins, renderDefault)} />
                    <Route path="/contracts" component={wrapAsync(contracts, renderDefault)} />
                    <Route path="/consultants" component={wrapAsync(consultants, renderConsultants)} />
                    <Route path="/consultantData" component={wrapAsync(consultantData, renderConsultants)} />
                    <Route path="/consultant/:id" component={wrapAsync(consultant, renderConsultant)} />
                    <Route path="/client/:id" component={wrapAsync(client, renderConsultant)} />
                    <Route path="/proposal2/:id" component={wrapAsync(proposal, renderProposal)} />
                    <Route path="/proposal/:id" component={wrapAsync(proposal3, renderProposal)} />
                    <Route path="/proposal3/:id" component={wrapAsync(proposal3, renderProposal)} />
                    <Route path="/proposals" component={wrapAsync(proposals, renderDefault)} />
                    <Route path="/account/:id" component={wrapAsync(account, renderAccount)} />
                    <Route path="/profile/:id" component={wrapAsync(profile, renderProfile)} />
                    <Route path="/profileVersions" component={wrapAsync(profileVersions, renderDefault)} />
                    <Route path="/proposal-profile/:proposalId/:consultantId" component={wrapAsync(profile, renderProfile)} />
                    <Route path="/availabilityCalendar/:id" component={wrapAsync(availability, renderAvailability)} />
                    <Route path="/availabilityCalendar" component={wrapAsync(availability, renderAvailability)} />
                    <Route path="/userLogs" component={wrapAsync(userLogs, renderUserLogs)} />
                    <Route path="/changePassword" component={wrapAsync(changePassword, renderDefault)} />
                    <Route path="/clients" component={wrapAsync(clients, renderDefault)}/>
                    <Route path="/kyc/:id/:token" component={wrapAsync(kyc, renderKyc)}/>
                    <Route path="/kyc/:id" component={wrapAsync(kyc, renderKyc)}/>
                    <Route path="/kycAdmin/:id" component={wrapAsync(kyc, renderKyc)}/>
                    <Route path="/reminders" component={wrapAsync(reminders, renderDefault)} />
                    <Route path="/toBeImplemented" render={toBeImplemented} />
                    <Route path="/test" component={wrapAsync(test, renderDefault)} />
                </Switch>
            </DocumentTitle>
        );
    }
}

const getAccountType = async () => {
    const sessionStatus = await ClientHome.sessionStatus();
    let accountType;
    if (sessionStatus.status === 403) {
        if (forceLoginHref()) {
            const loc = location.href.split('#')[1] || '/';
            const redirect = loc === '/' ? null : location.href;
            location.href = redirect ? '#/login?redirect=' + location.href : '#/login';
        }
    } else {
        accountType = await sessionStatus.json();
        console.log('accountType', accountType);
        if (forceHomeHref()) {
            location.href = '#/home';
        }
    }
    return accountType || {};
};

const main = async () => {

    const {type, id, superAdmin, kycAdmin} = await getAccountType();
    ReactDOM.render(
        <HashRouter>
            <App accountType={type} id={id} superAdmin={superAdmin} kycAdmin={kycAdmin} />
        </HashRouter>,
        document.getElementById('root') as HTMLElement
    );

};
main();
registerServiceWorker();

(window as any).dev = () => location.href = `http://localhost:3000/#${location.href.split('#')[1]}`;
(window as any).stg = () => location.href = `https://stg.axceller.com/#${location.href.split('#')[1]}`;
(window as any).prod = () => location.href = `https://axceller.com/#${location.href.split('#')[1]}`;

// A note to my successor:
// In 2018 due to a billing miscommunication Korum refused to pay my salary for several months.
// During this time I stopped working for them and they eventually backed down and paid up.
// I then agreed to continue working for them, however the trust has never quite returned.
// As a precaution I am leaving this message until I get my last paycheck.
// Any questions please reach out whamtet@gmail.com
// Best wishes
// Matthew Molloy



// WEBPACK FOOTER //
// ./src/index.tsx